import React, { FC } from "react";
import { TAB_CAMPAIGNS, PATH_CAMPAIGNS } from "constants/paths";
import TabOptions from "modules/Common/Components/TabOptions";
import styled from "styled-components";
import { getQueryParam } from "utils";
import { IDS_CAMPAIGNS_AUDIENCE } from "constants/onBoardingIds";

interface ICampaignsTab {
  tab?: string;
  page?: string;
}

const CampaignsTab: FC<ICampaignsTab> = (props) => {
  const { tab, page } = props;
  const tabsArray = [
    {
      pillName: "Dashboard",
      to: `/${PATH_CAMPAIGNS}/${TAB_CAMPAIGNS.CONTENT}?campaign_id=${getQueryParam("campaign_id")}`,
      isActive: page === TAB_CAMPAIGNS.CONTENT && (tab === undefined || tab === "/"),
      id: IDS_CAMPAIGNS_AUDIENCE.DASHBOARD_CAMPAIGN,
    },
    {
      pillName: "SmartSourced Content",
      to: `/${PATH_CAMPAIGNS}/${page}/${TAB_CAMPAIGNS.SOURCED_CONTENT}?campaign_id=${getQueryParam(
        "campaign_id"
      )}`,
      isActive: tab === TAB_CAMPAIGNS.SOURCED_CONTENT,
      id: "SmartSourced-Content-Tab-Campaign-Page",
    },
    {
      pillName: "Audience",
      to: `/${PATH_CAMPAIGNS}/${page}/${TAB_CAMPAIGNS.AUDIENCE}?campaign_id=${getQueryParam("campaign_id")}`,
      isActive: tab === TAB_CAMPAIGNS.AUDIENCE,
      id: "Audience-Tab-Campaign-Page",
    },
  ];
  return (
    <div id={"campaigns-tabs"} className="margin-bottom-sm margin-top-sm">
      <Wrapper>
        <TabOptions tabArray={tabsArray} />
      </Wrapper>
    </div>
  );
};

export default CampaignsTab;

const Wrapper = styled.div`
  justify-content: space-between;
  align-items: center;
  margin-left: -5px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding-bottom: 12px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    li {
      margin: 5px 5px;
    }
  }
  p.articles-count {
    margin-bottom: 0px;
    color: rgb(126, 126, 126);
    font-size: 14px;
    font-weight: 600;
    font-family: "robotomedium";
    white-space: nowrap;
    display: inline-block;
    float: right;
  }
`;
